// src/enums/DataKeys.js
const DataKeys = Object.freeze({
  GET_PERIODICAL_RESULT: 'GET_PERIODICAL_RESULT',
  SAVE_PERIODICAL_RESULT: 'SAVE_PERIODICAL_RESULT', 
  GET_HGFARMER_RESULT: 'GET_HGFARMER_RESULT',
  SAVE_HGFARMER_RESULT: 'SAVE_HGFARMER_RESULT', 
  GET_MIXEDMODE_RESULT: 'GET_MIXEDMODE_RESULT',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  MODAL_STATUS: 'MODAL_STATUS',
  UPDATE_MIXEDMODE_RESULT: 'UPDATE_MIXEDMODE_RESULT',
  SAVE_DEFAULT_ETHNICITY: 'SAVE_DEFAULT_ETHNICITY',
  ERROR_HANDLER: 'ERROR_HANDLER',
  STATISTICS: 'STATISTICS',
  MOBILE_APP_OPEN_EXTERNAL_LINK: 'MOBILE_APP_OPEN_EXTERNAL_LINK',
  MOBILE_APP_DOWNLOAD_VIDEO: 'MOBILE_APP_DOWNLOAD_VIDEO',
});

export default DataKeys;
